export default {
    title: 'Components/AmwalPos',
    parameters: {
        notes: require('./readme.md')
    },
    argTypes: {
        locale: {
            options: ['en', 'ar'],
            control: { type: 'select' },
            description: 'Language locale for the component'
        },
        currency: {
            options: ['AED', 'SAR'],
            control: { type: 'select' },
            description: 'Currency to display (AED for UAE, SAR for KSA)'
        },
        amount: {
            control: { type: 'text' },
            description: 'Initial amount value'
        },
        minAmount: {
            control: { type: 'number', min: 0, step: 0.01 },
            description: 'Minimum allowed amount'
        },
        maxAmount: {
            control: { type: 'number', min: 1, step: 1 },
            description: 'Maximum allowed amount'
        },
        debug: {
            control: { type: 'boolean' },
            description: 'Enable debug mode for console logging'
        },
        authToken: {
            control: { type: 'text' },
            description: 'API Authorization token'
        },
        storeId: {
            control: { type: 'text' },
            description: 'Store ID for API calls'
        },
        apiBaseUrl: {
            control: { type: 'text' },
            description: 'API base URL'
        },
        paymentTitle: {
            control: { type: 'text' },
            description: 'Custom title for payment'
        },
        paymentDescription: {
            control: { type: 'text' },
            description: 'Custom description for payment'
        },
        customerFirstName: {
            control: { type: 'text' },
            description: 'Customer first name'
        },
        customerLastName: {
            control: { type: 'text' },
            description: 'Customer last name'
        },
        customerEmail: {
            control: { type: 'text' },
            description: 'Customer email address'
        },
        customerPhone: {
            control: { type: 'text' },
            description: 'Customer phone number'
        },
        customerStreet1: {
            control: { type: 'text' },
            description: 'Customer street address line 1'
        },
        customerStreet2: {
            control: { type: 'text' },
            description: 'Customer street address line 2'
        },
        customerCity: {
            control: { type: 'text' },
            description: 'Customer city'
        },
        customerState: {
            control: { type: 'text' },
            description: 'Customer state/province'
        },
        customerCountry: {
            control: { type: 'text' },
            description: 'Customer country code (e.g., SA)'
        },
        customerPostcode: {
            control: { type: 'text' },
            description: 'Customer postal/ZIP code'
        },
        addressRequired: {
            control: { type: 'boolean' },
            description: 'Require address during payment'
        },
        smsLanguage: {
            control: { type: 'text' },
            description: 'SMS language (ar/en)'
        },
        sendSms: {
            control: { type: 'boolean' },
            description: 'Send SMS notifications'
        },
        passkeyEnabled: {
            control: { type: 'boolean' },
            description: 'Enable passkey authentication'
        },
        onlyShowBankInstallments: {
            control: { type: 'boolean' },
            description: 'Only show bank installment options'
        },
        onlyShowPayInFull: {
            control: { type: 'boolean' },
            description: 'Only show full payment option'
        },
        callbackUrl: {
            control: { type: 'text' },
            description: 'Callback URL for payment completion'
        },
        metadata: {
            control: { type: 'text' },
            description: 'Custom metadata as JSON string'
        },
    },
};

const Template = (args) => `
  <amwal-pos
      amount="${args.amount || ''}"
      currency="${args.currency}"
      locale="${args.locale}"  
      min-amount="${args.minAmount}"
      max-amount="${args.maxAmount}"
      debug="${args.debug}"
      auth-token="${args.authToken || ''}"
      store-id="${args.storeId || ''}"
      api-base-url="${args.apiBaseUrl}"
      payment-title="${args.paymentTitle || ''}"
      payment-description="${args.paymentDescription || ''}"
      customer-first-name="${args.customerFirstName || ''}"
      customer-last-name="${args.customerLastName || ''}"
      customer-email="${args.customerEmail || ''}"
      customer-phone="${args.customerPhone || ''}"
      customer-street1="${args.customerStreet1 || ''}"
      customer-street2="${args.customerStreet2 || ''}"
      customer-city="${args.customerCity || ''}"
      customer-state="${args.customerState || ''}"
      customer-country="${args.customerCountry || ''}"
      customer-postcode="${args.customerPostcode || ''}"
      address-required="${args.addressRequired || false}"
      sms-language="${args.smsLanguage || ''}"
      send-sms="${args.sendSms || false}"
      passkey-enabled="${args.passkeyEnabled || false}"
      only-show-bank-installments="${args.onlyShowBankInstallments || false}"
      only-show-pay-in-full="${args.onlyShowPayInFull || false}"
      callback-url="${args.callbackUrl || ''}"
      metadata='${args.metadata || ''}'>
    </amwal-pos>
  <script>
    document.querySelectorAll('amwal-pos').forEach((posElement) => {
      console.log('AmwalPos initialized');
      
      if (posElement.debug) {
        console.log('POS Debug Mode:', {
          amount: posElement.amount,
          currency: posElement.currency,
          locale: posElement.locale,
          minAmount: posElement.minAmount,
          maxAmount: posElement.maxAmount,
          authToken: posElement.authToken ? '***' : 'Not set',
          storeId: posElement.storeId || 'Not set',
          apiBaseUrl: posElement.apiBaseUrl,
          customerInfo: {
            firstName: posElement.customerFirstName,
            lastName: posElement.customerLastName,
            email: posElement.customerEmail,
            phone: posElement.customerPhone,
            address: {
              street1: posElement.customerStreet1,
              street2: posElement.customerStreet2,
              city: posElement.customerCity,
              state: posElement.customerState,
              country: posElement.customerCountry,
              postcode: posElement.customerPostcode
            }
          }
        });
      }

      // Listen for custom events if needed
      posElement.addEventListener('amwal-pos-amount-changed', (event) => {
        console.log('Amount changed:', event.detail);
      });

      posElement.addEventListener('amwal-pos-payment-initiated', (event) => {
        console.log('Payment initiated:', event.detail);
      });

      posElement.addEventListener('amwal-pos-payment-completed', (event) => {
        console.log('Payment completed:', event.detail);
      });

      posElement.addEventListener('amwal-pos-payment-cancelled', (event) => {
        console.log('Payment cancelled:', event.detail);
      });

      posElement.addEventListener('amwal-pos-error', (event) => {
        console.log('POS Error:', event.detail);
      });
    });
  </script>
`;

export const Default = Template.bind({});
Default.args = {
    amount: '',
    currency: 'SAR',
    locale: 'en',
    minAmount: 1,
    maxAmount: 999999,
    debug: true,
    authToken: '',
    storeId: '',
    apiBaseUrl: 'https://backend.sa.amwal.tech',
    paymentTitle: '',
    paymentDescription: '',
    customerFirstName: '',
    customerLastName: '',
    customerEmail: '',
    customerPhone: '',
    customerStreet1: '',
    customerStreet2: '',
    customerCity: '',
    customerState: '',
    customerCountry: '',
    customerPostcode: '',
    addressRequired: false,
    smsLanguage: '',
    sendSms: false,
    passkeyEnabled: false,
    onlyShowBankInstallments: false,
    onlyShowPayInFull: false,
    callbackUrl: '',
    metadata: '',
};

export const APIConfiguration = Template.bind({});
APIConfiguration.args = {
    amount: '',
    currency: 'SAR',
    locale: 'en',
    minAmount: 1,
    maxAmount: 999999,
    debug: true,
    authToken: 'd9ccf8bc-ed63-44ad-a54c-9d8fee63df6b',
    storeId: 'f24267bd-79f4-433f-a9f2-485c171301e4',
    apiBaseUrl: 'https://backend.sa.amwal.tech',
    paymentTitle: 'POS Payment',
    paymentDescription: 'Point of Sale Transaction',
    customerFirstName: 'Ahmed',
    customerLastName: 'Al-Rashid',
    customerEmail: 'ahmed@example.com',
    customerPhone: '+966501234567',
    customerStreet1: '123 King Fahd Road',
    customerStreet2: 'Suite 100',
    customerCity: 'Riyadh',
    customerState: 'Riyadh Province',
    customerCountry: 'SA',
    customerPostcode: '12345',
    addressRequired: false,
    smsLanguage: 'ar',
    sendSms: true,
    passkeyEnabled: false,
    onlyShowBankInstallments: false,
    onlyShowPayInFull: false,
    callbackUrl: 'https://shop.amwal.tech/webhook/payment-complete',
    metadata: '{"store_location": "Riyadh Main Branch", "cashier_id": "EMP001", "terminal": "POS-001"}',
};

export const ArabicLocale = Template.bind({});
ArabicLocale.args = {
    amount: '',
    currency: 'SAR',
    locale: 'ar',
    minAmount: 1,
    maxAmount: 999999,
    debug: true,
    authToken: 'd9ccf8bc-ed63-44ad-a54c-9d8fee63df6b',
    storeId: 'f24267bd-79f4-433f-a9f2-485c171301e4',
    apiBaseUrl: 'https://backend.sa.amwal.tech',
    paymentTitle: 'دفع نقطة البيع',
    paymentDescription: 'معاملة نقطة البيع',
    customerFirstName: 'أحمد',
    customerLastName: 'الراشد',
    customerEmail: 'ahmed@example.com',
    customerPhone: '+966501234567',
    customerStreet1: '123 طريق الملك فهد',
    customerStreet2: 'جناح 100',
    customerCity: 'الرياض',
    customerState: 'منطقة الرياض',
    customerCountry: 'SA',
    customerPostcode: '12345',
    addressRequired: false,
    smsLanguage: 'ar',
    sendSms: true,
    passkeyEnabled: false,
    onlyShowBankInstallments: false,
    onlyShowPayInFull: false,
    callbackUrl: 'https://shop.amwal.tech/webhook/payment-complete',
    metadata: '{"store_location": "فرع الرياض الرئيسي", "cashier_id": "EMP001", "terminal": "POS-001"}',
};